export default {
  page_title: '捐款人',
  curr: '现时的捐款人',
  past: '过去的捐款人',
  indi: '个人',
  firm: '律师行',
  intro: [
    'HKLII 感谢以下人士和律师行的慷慨捐助，以支持 HKLII 提供免费法律资讯：'
  ],
  donation_page: '损款网页',
  thanks: [
    'HKLII 感谢以上所有捐款人为 HKLII 的成功作出贡献。如果您有兴趣捐赠予 HKLII，请转到我们的{0}。如果您有任何疑问，请按{1}。'
  ]
}